import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { apiError } from "@/lib/apiError";

// Global axios interceptor: coerce FastAPI 422 (list of dicts) into a safe string in error.response.data.detail
axios.interceptors.response.use(
  (r) => r,
  (err) => {
    try {
      if (err?.response?.data?.detail && typeof err.response.data.detail !== "string") {
        err.response.data.detail = apiError(err);
      }
    } catch { /* noop */ }
    return Promise.reject(err);
  }
);

// PWA: register the service worker early (offline shell + push + installability)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((e) => console.warn("[pwa] SW register failed", e?.message));
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
